<p-toast></p-toast>
<div class="email-verificn-dialog-container">
  <div class="dialog-content">
    <div class="logo-container">
      <img class="logo-img" src="assets/icons/logo.png" alt="logo" />
    </div>

    <div class="header">
      <!-- <button class="back-btn" type="button" (click)="navigateBackToForm()">
        <img src="assets/icons/chevron-up.png" alt="Back" />
      </button> -->
      <p class="dialog-title">verify your email</p>
    </div>

    <div class="body">
      <p class="description">
        enter the 6 digit code we sent to <strong>{{email}}</strong>
      </p>

      <form #otpForm="ngForm" (ngSubmit)="navigatetoProfile()">
        <div class="otp-input-container">
          <input pInputText #otp1Input [(ngModel)]="otp1" name="otp1" type="text" class="otp-input" maxlength="1"
            required (input)="focusNext($event, otp2Input)"  (paste)="handlePaste($event)" (keydown)="handleKeydown($event, null)" />

          <input pInputText #otp2Input [(ngModel)]="otp2" name="otp2" type="text" class="otp-input" maxlength="1"
            required (input)="focusNext($event, otp3Input)" (keydown)="handleKeydown($event, otp1Input)" />

          <input pInputText #otp3Input [(ngModel)]="otp3" name="otp3" type="text" class="otp-input" maxlength="1"
            required (input)="focusNext($event, otp4Input)" (keydown)="handleKeydown($event, otp2Input)" />

          <input pInputText #otp4Input [(ngModel)]="otp4" name="otp4" type="text" class="otp-input" maxlength="1"
            required (input)="focusNext($event, otp5Input)" (keydown)="handleKeydown($event, otp3Input)" />

          <input pInputText #otp5Input [(ngModel)]="otp5" name="otp5" type="text" class="otp-input" maxlength="1"
            required (input)="focusNext($event, otp6Input)" (keydown)="handleKeydown($event, otp4Input)" />

          <input pInputText #otp6Input [(ngModel)]="otp6" name="otp6" type="text" class="otp-input" maxlength="1"
            required (keydown)="handleKeydown($event, otp5Input)" />
        </div>

        <button type="submit" class="continue-btn" [disabled]="formSubmitted">
          @if (formSubmitted) {
          <span>Verifying...</span>
          } @else {
          <span>continue</span>
          }
        </button>
      </form>

      <p class="resend-code" (click)="resendCode()">
        didn't get the code? <span class="resend-link">resend code</span>
      </p>
    </div>
  </div>
</div>